// removed by extract-text-webpack-plugin
module.exports = {"pad":"pad___D6fkg"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Tooltip/TooltipPad/index.scss
// module id = 111
// module chunks = 0